exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SegmentPopup-2c7dbb1c{width:300px}.SegmentPopup-2c7dbb1c .metrics-b71ce40b{display:flex;position:relative;flex-wrap:wrap;margin-bottom:-5px}.SegmentPopup-2c7dbb1c .metric-c7f719d1{flex:1 1 32%;max-width:33%;min-width:30%;padding-bottom:10px}.SegmentPopup-2c7dbb1c .metric-c7f719d1 .value-8958c3a6{font-weight:bold;font-size:14px;margin-bottom:2px}\n", ""]);

// Exports
exports.locals = {
	"SegmentPopup": "SegmentPopup-2c7dbb1c",
	"metrics": "metrics-b71ce40b",
	"metric": "metric-c7f719d1",
	"value": "value-8958c3a6"
};